import { Box, Skeleton } from "@mui/material";

const ClientCardSkeleton = () => {
  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        borderRadius: 1,
        padding: "1rem",
        boxShadow: 4,
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        gap: "5px",
        alignItems: "center"
      }}
    >
      <Box
        className="w-full mt-4"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Skeleton
          variant="rectangular"
          width={192}
          height={80}
          sx={{ borderRadius: 1 }}
        />
      </Box>
      <Skeleton variant="text" width="60%" height={40} />
    </Box>
  );
};

export default ClientCardSkeleton;
